import * as React from "react";
import { sendRequest } from "../../helpers/ajax";
import IResponse from "../../types/IResponse";
import ISendMessageRequest from "../../types/ISendMessageRequest";
import { ISendMessageResponse } from "../../types/ISendMessageResponse";
import SendMessage from "./SendMessage";

interface ISendMessageContainerState {
    loading: boolean;
}

class SendMessageContainer extends React.Component<{}, ISendMessageContainerState> {

    constructor(props: {}) {
        super(props)

        this.state = { loading: false };

        this.sendMessage = this.sendMessage.bind(this);
    }

    public render() {
        return (
            <SendMessage loading={this.state.loading} sendMessage={this.sendMessage} />
        );
    }

    private async sendMessage(request: ISendMessageRequest): Promise<IResponse<ISendMessageResponse> | null> {

        this.setState({ loading: true });

        const response = await sendRequest<IResponse<ISendMessageResponse>>("/api/message/sendmessage", "POST", request);

        this.setState({ loading: false });

        return response;
    }

}

export default SendMessageContainer;



// WEBPACK FOOTER //
// ./src/components/SendMessage/SendMessageContainer.tsx